import { ANALYTICS_GET_META } from '~/gql/analytics/analyticsGetMeta'
import { useScopeStore } from '~/stores/scope'
import { type Meta, type Dimension, type Measure } from '~/types/cube'
import type { ScopeType } from '~/types/permissions'

interface State {
  meta: Meta | null
  measuresMeta: Measure[] | null
  dimensionsMeta: Dimension[] | null
  scopeTypeUsedToComputeMeta: ScopeType | null
}

export const useCubeStore = defineStore('cube', {
  state: (): State => ({
    meta: null,
    measuresMeta: null,
    dimensionsMeta: null,
    scopeTypeUsedToComputeMeta: null
  }),
  actions: {
    async loadMeta(forceMetaReload: boolean = false) {
      const { scopeType } = useScopeStore()
      // We load meta only if they are not already set we or if we force the meta reload or if we are using a different scope
      if (
        !this.meta ||
        forceMetaReload ||
        this.scopeTypeUsedToComputeMeta !== scopeType
      ) {
        const app = useNuxtApp()

        const meta = (
          await app.$apiGqlClient.query({
            query: ANALYTICS_GET_META,
            variables: { scopeType }
          })
        ).data.analyticsGetMeta as Meta

        const measuresMeta = meta.cubes.map(cube => cube.measures).flat()

        const dimensionsMeta = meta.cubes.map(cube => cube.dimensions).flat()

        this.meta = meta
        this.measuresMeta = measuresMeta
        this.dimensionsMeta = dimensionsMeta
        this.scopeTypeUsedToComputeMeta = scopeType
      }
    }
  }
})
